module.exports = __webpack_public_path__ + "application/templates/default/inner/module-schedule/module-schedule.template.html";